import { Lightning, Router, Utils } from '@lightningjs/sdk'

export default class Splash extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      colorUl: 0xff1ba9f9,
      colorUr: 0xff1c8bf5,
      colorBl: 0xff1c89f5,
      colorBr: 0xff1e6af2,
      // BG: {w: 1920, h: 1080, src: Utils.asset('/images/splashBG.png')},
      VersionLabel: {
        x: 1800,
        y: 980,
        mountX: 1,
        color: 0xffffffff,
        text: {
          text: '',
          textAlign: 'right',
          fontSize: 30,
          fontFace: 'OpenSansLight',
          lineHeight: 40,
        },
      },
      AnimWrapper: {
        w: 260,
        h: 270,
        x: 1920 / 2,
        y: 405,
        mountX: 0.5,
        clipping: true,
        SplashLogo: { w: 1058, h: 270, src: Utils.asset('images/splashLogo.png') },
      },
    }
  }

  _init() {
    this._logoAnimation = this.tag('AnimWrapper').animation({
      duration: 0.5,
      repeat: 0,
      actions: [{ p: 'w', v: { sm: 0, 0: 260, 1: 1058 } }],
    })

    setTimeout(() => {
      Router.resume()
    }, 2000)
  }

  _active() {
    this._logoAnimation.start()
    this.tag('VersionLabel').text = 'v' + this.application.config.version
  }
  _inactive() {
    this.stage.gc()
  }
}
